import { haversineKm } from "./cost.js";

export async function loadCameras(signal) {
  const response = await fetch("/api/cameras", { signal, headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error("No se pudo cargar el catálogo de cámaras de la DGT");
  const payload = await response.json();
  if (!Array.isArray(payload.cameras)) throw new Error("El catálogo de cámaras de la DGT no tiene un formato válido");
  return { ...payload, cameras: payload.cameras.map((camera) => ({ ...camera, name: cameraName(camera) })) };
}

export function cameraName(camera) {
  const road = camera.road || "Carretera";
  const km = String(camera.km || "").replace(".", ",");
  return km ? `${road} · km ${km}` : road;
}

export function filterCameras(cameras, query) {
  const needle = String(query || "").trim().toLocaleLowerCase("es");
  if (!needle) return cameras;
  return cameras.filter((camera) => `${camera.name} ${camera.road} ${camera.km} ${camera.province}`.toLocaleLowerCase("es").includes(needle));
}

// Con un punto de referencia, las cámaras se ordenan por cercanía; sin él, por carretera y kilómetro.
export function sortCameras(cameras, reference) {
  if (reference) {
    return cameras
      .map((camera) => ({ ...camera, distanceFromKm: haversineKm(reference, camera) }))
      .sort((left, right) => left.distanceFromKm - right.distanceFromKm);
  }
  return [...cameras].sort((left, right) => String(left.road).localeCompare(String(right.road), "es", { numeric: true })
    || Number.parseFloat(left.km) - Number.parseFloat(right.km));
}
